/**
 * Checks if a given URL is safe for redirection.
 *
 * - Relative URLs (starting with "/") are considered safe.
 * - Absolute URLs are considered safe only if:
 *    - Their protocol is HTTPS.
 *    - Their hostname is in the provided allowed domains list, or is a subdomain of one of the allowed domains.
 *
 * @param url - The URL to validate.
 * @param allowedDomains - List of allowed hostnames.
 * @returns {boolean} - True if the URL is safe; otherwise, false.
 */
export const isSafeRedirect = (url: string, allowedDomains: string[]): boolean => {
    if (url.startsWith('/')) {
        return true;
    }
    try {
        const parsedUrl = new URL(url);
        return (
            parsedUrl.protocol === 'https:' &&
            allowedDomains.some((domain) => {
                return parsedUrl.hostname === domain || parsedUrl.hostname.endsWith(`.${domain}`);
            })
        );
    } catch {
        return false;
    }
};
